module.exports = __webpack_public_path__ + "static/media/machen.b9c661d3.svg";